import { deleteFromArray, updateArray } from 'helpers/helperFuncs'
import { IShift, IShiftsReducer } from 'models/Shift'
import { Action } from 'redux'
import { isType } from 'ts-action'
import {
  ClearUpshifterShiftsReducer,
  GetUpshifterShifts,
  UpshifterShiftsFavoriteBusiness,
  UpshifterShiftsFetching,
  UpshifterShiftsRemoveShift,
  UpshifterShiftsSetHasMore,
  UpshifterShiftsUnfavoriteBusiness,
  UpshifterShiftsUpdateApplicants,
  UpshifterShiftsUpdateShift,
} from './actions'

const initialState: IShiftsReducer = {
  meta: {
    code: 0,
    message: '',
  },
  isFetching: false,
  data: [],
  hasMore: false,
}

export const upshifterShiftsReducer = (
  state = initialState,
  action: Action,
): IShiftsReducer => {
  if (isType(action, GetUpshifterShifts)) {
    const { data, meta } = action.payload
    const currentShiftIds = state.data.map(shift => shift.id)
    const filteredShifts = data.filter(
      element => !currentShiftIds.includes(element.id),
    )
    const hasMore = meta.pagination
      ? meta.pagination.total_pages > meta.pagination.current_page
      : false
    return {
      ...state,
      meta: meta,
      data: [...state.data, ...filteredShifts],
      hasMore,
      error: undefined,
    }
  }
  if (isType(action, UpshifterShiftsFetching)) {
    const { payload } = action
    return {
      ...state,
      isFetching: payload,
    }
  }
  if (isType(action, UpshifterShiftsSetHasMore)) {
    const { payload } = action
    return {
      ...state,
      hasMore: payload,
    }
  }
  if (isType(action, UpshifterShiftsUpdateShift)) {
    const { payload } = action
    const formattedArray = updateArray<IShift>(state.data, payload)
    return {
      ...state,
      data: formattedArray,
    }
  }
  if (isType(action, UpshifterShiftsRemoveShift)) {
    const { payload: id } = action
    const formattedArray = deleteFromArray<IShift>(state.data, id)
    return {
      ...state,
      data: formattedArray,
    }
  }
  if (isType(action, UpshifterShiftsFavoriteBusiness)) {
    const { payload } = action
    const modifiedShifts = state.data.map(shift => {
      if (shift.business_id === payload.model_favored.id) {
        const modifiedShift = shift
        modifiedShift.favored = true
        modifiedShift.favorite_id = payload.id
        return modifiedShift
      }
      return shift
    })
    return {
      ...state,
      data: modifiedShifts,
    }
  }
  if (isType(action, UpshifterShiftsUnfavoriteBusiness)) {
    const { payload } = action
    const unfavoritedShifts = state.data.map(shift => {
      if (shift.business_id === payload) {
        const unfavoritedShift = shift
        unfavoritedShift.favored = false
        unfavoritedShift.favorite_id = null
        return unfavoritedShift
      }
      return shift
    })
    return {
      ...state,
      data: unfavoritedShifts,
    }
  }
  if (isType(action, UpshifterShiftsUpdateApplicants)) {
    const { shiftId, applicants } = action.payload
    const newShifts = state.data.map(shift => {
      if (shift.id === shiftId) {
        const newShift = { ...shift, applicants }
        return newShift
      }
      return shift
    })
    return { ...state, data: newShifts }
  }
  if (isType(action, ClearUpshifterShiftsReducer)) {
    return initialState
  }
  return state
}
